import axios from "axios"
axios.defaults.timeout = 40000;


// WEBPACK FOOTER //
// ./src/ajax/defaultsetting.js